import { ScreenAppMenu, ScreenAuthLanding, ScreenDeeplink } from "../../../shared/utils/Constants";

type RouteLocation = { pathname: string; search: string; hash: string };
const parsingOrigin = "https://lili.invalid";

/** Only accept paths within the app, never an external redirect. */
export function getInternalDestination(value: unknown): string | null {
    if (typeof value !== "string" || !value.startsWith("/") || value.startsWith("//") || /[\\\u0000-\u001f]/.test(value)) {
        return null;
    }
    try {
        const url = new URL(value, parsingOrigin);
        if (url.origin !== parsingOrigin) return null;
        return url.pathname + url.search + url.hash;
    } catch {
        return null;
    }
}

export function getReturnDestination(search: string): string {
    const destination = getInternalDestination(new URLSearchParams(search).get("returnTo"));
    if (destination === null) return ScreenAppMenu;
    const { pathname } = new URL(destination, parsingOrigin);
    // Avoid returning to the login page or nesting login/deeplink redirects.
    if (pathname === "/" || pathname === ScreenAuthLanding || pathname.startsWith(ScreenAuthLanding + "/") || pathname === ScreenDeeplink || pathname.startsWith(ScreenDeeplink + "/")) {
        return ScreenAppMenu;
    }
    return destination;
}

export function getSignInDestination(location: RouteLocation): string {
    const returnTo = location.pathname + location.search + location.hash;
    return ScreenAuthLanding + "?" + new URLSearchParams({ returnTo }).toString();
}

/** Compatibility with /deeplink/%2Fpath and /deeplink/path. */
export function getDeepLinkDestination(location: RouteLocation): string | null {
    console.log({location});
    const prefix = ScreenDeeplink + "/";
    if (!location.pathname.startsWith(prefix)) return null;
    let path = location.pathname.slice(prefix.length);
    if (!path) return null;
    try {
        // Decode the wrapper once, keeping encoded values inside the target intact.
        if (/^%2f/i.test(path)) path = decodeURIComponent(path);
        else if (!path.startsWith("/")) path = "/" + path;
        const destination = getInternalDestination(path);
        if (destination === null) return null;
        const url = new URL(destination, parsingOrigin);
        if (url.pathname === ScreenDeeplink || url.pathname.startsWith(prefix)) return null;
        if (location.search) {
            const outerParams = new URLSearchParams(location.search);
            outerParams.forEach((value, key) => url.searchParams.append(key, value));
        }
        if (location.hash) url.hash = location.hash;
        return url.pathname + url.search + url.hash;
    } catch {
        return null;
    }
}
